import React, { useEffect, useState, useRef } from "react";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";
import { handleDeepLink } from "@/service/utils";

function Login() {
  const { memberStore } = useStores();
  const locale = memberStore.getLocale();
  const hostWidgetRef = useRef(null);

  function refresh() {
    const { region, regionId, region_id } = getQuery();
    const element = hostWidgetRef.current;
    if (!element) {
      return undefined;
    }
    console.log("refresh login widget", {
      locale,
      region,
      regionId,
      region_id,
    });
    element.locale = locale.locale;
    element.regionId = region || regionId || region_id;
    element.env =
      process.env.REACT_APP_MODE === "PRODUTION" ? "production" : "staging";
  }

  useEffect(() => {
    const element = hostWidgetRef.current;
    if (!element) {
      return undefined;
    }

    refresh();

    const handleEvent = async (event) => {
      const { type, detail } = event;
      switch (type) {
        case "open-change":
          hostWidgetRef.current.open = detail?.open === true;
          if (detail?.open) {
            document.body.classList.add("is-login");
          } else {
            document.body.classList.remove("is-login");
          }
          break;
        case "login-success":
          window.private_token = detail?.data.private_token;
          localStorage.setItem("private_token", window.private_token);
          await memberStore.show(true);
          const returnUrl = window.localStorage.getItem("login_return_url");
          window.localStorage.removeItem("login_return_url");
          if (returnUrl) {
            handleDeepLink(returnUrl);
          }
          break;

        default:
          break;
      }
    };

    window.addEventListener("haschange", refresh);
    window.addEventListener("popstate", refresh);

    element.addEventListener("login-success", handleEvent);
    element.addEventListener("open-change", handleEvent);

    return () => {
      element.removeEventListener("login-success", handleEvent);
      element.removeEventListener("open-change", handleEvent);
      window.removeEventListener("haschange", refresh);
      window.removeEventListener("popstate", refresh);
    };
  }, []);

  useEffect(() => {
    refresh();
  }, [locale]);

  return <dc-login ref={hostWidgetRef} id="loginWidget"></dc-login>;
}

export default Login;
